import { locales } from '../locales/en'

const GUEST_BANNER_TEXT = 'Create a FREE account today'
const BASIC_BANNER_TEXT = 'Buy Tokens & Go Premium'
export const BANNER_TEXT_ENDORNMENT = '🎁🏆🎉🥇'

export const getPromotionalBannerText = (isGuest: boolean, reason?: string) => {
    const offer = isGuest ? GUEST_BANNER_TEXT : BASIC_BANNER_TEXT
    return `${offer}${reason ? ` ${reason}` : ''}! ${BANNER_TEXT_ENDORNMENT}`
}

/** Local-clock hours (0-23) at which each greeting begins */
export const MORNING_STARTS_AT = 5
export const AFTERNOON_STARTS_AT = 12
export const EVENING_STARTS_AT = 17

/**
 * Time-of-day greeting for the home banner, keyed off the user's local clock:
 * morning from 5am until noon, afternoon until 5pm, evening from then through
 * the small hours.
 */
export const getGreetingBannerText = (
    username: string | undefined,
    now: Date = new Date(),
) => {
    const hour = now.getHours()
    const greeting =
        hour >= MORNING_STARTS_AT && hour < AFTERNOON_STARTS_AT
            ? locales.home.goodMorning
            : hour >= AFTERNOON_STARTS_AT && hour < EVENING_STARTS_AT
              ? locales.home.goodAfternoon
              : locales.home.goodEvening

    return greeting.replace('{{username}}', username ?? '') + ' 🙂'
}
